import { IconButton } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ActionTooltip from './ActionTooltip';

type ActionDetailLinkProps = {
  href: string;
  disabled?: boolean;
  color?: 'primary' | undefined;
  tooltipPosition?: 'bottom' | 'left' | undefined;
};

const ActionDetailLink = ({ href, disabled, color, tooltipPosition }: ActionDetailLinkProps) => {
  const { t } = useTranslation();
  return (
    <ActionTooltip title={t('navigation.detailPage')} disabled={disabled} position={tooltipPosition}>
      <IconButton disabled={disabled} size="small" href={href} target="_blank" color={color}>
        <Search />
      </IconButton>
    </ActionTooltip>
  );
};

export default memo(ActionDetailLink);
